<template>
<div id="sample-view" class="relative overflow-hidden">
    <component :is="scrollbarTag" class="scroll-area-sample-content" :settings="settings">
      <div class="vx-row">
        <div class="vx-col w-1/3 mb-base" >
          <vx-card ref="dateCard" :title="$t('GradeControl.Sample.MonthlyStats')"  class="sample-list-filters mb-8" title-color="black" refresh-content-action @refresh="refreshStats">
            <vs-row vs-type="flex" vs-justify="space-between">
              <vs-col vs-w="6" class="m-3" >
                <form-label>{{$t('GradeControl.Sample.CertifiedDate')}}</form-label>
                <datepicker format="yyyy-MM-dd"
                  :placeholder="$t('SelectDate')"
                  v-model="selectedDateTime"></datepicker>
              </vs-col>
            </vs-row>
            <vs-row class="mb-3">
              <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="12">
                <vs-button type="line" color="primary" @click="displayAllNotImported">{{ $t("GradeControl.Sample.OnlyNonApprouved") }}</vs-button>
              </vs-col>
            </vs-row>
            <vs-row>
               <lims-sample-stats ref="limsStats" :projectId="selectedProjectId" @onDateSelected="selectDate" />
            </vs-row>
          </vx-card>
        </div>
        <div class="vx-col w-2/3 mb-base" >
          <vx-card ref="sampleListCard" v-show="selectedSampleDate || displayNotImported" :title="sampleListTitle"  class="sample-list-filters mb-8" title-color="black"  refresh-content-action @refresh="getSampleEntries">
             <vs-row vs-type="flex" vs-justify="space-between">
              <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-lg="6"  class="ml-3 mr-3" >
                <vs-checkbox v-model="showOnlyWarning">{{$t('GradeControl.Sample.OnlyWarnings')}}</vs-checkbox>
              </vs-col>
              <vs-col vs-type="flex" vs-justify="flex-end" vs-align="center" vs-lg="4"  class="mr-3" >
                <vx-tooltip :text="$t('Import')" position="bottom" delay=".3s">
                  <feather-icon icon="CheckCircleIcon" class="cursor-pointer ml-5" svg-classes="h-6 w-6" @click="openImportConfirm" />
                </vx-tooltip>
                <vx-tooltip :text="$t('CancelImport')" position="bottom" delay=".3s">
                  <feather-icon icon="XCircleIcon" class="cursor-pointer ml-5" svg-classes="h-6 w-6" @click="openCancelImportConfirm" />
                </vx-tooltip>
              </vs-col>
            </vs-row>
            <ag-grid-vue
                ref="agGridTable"
                :components="components"
                :gridOptions="gridOptions"
                :context="context"
                class="ag-theme-material w-100 my-4 ag-grid-table"
                :columnDefs="columnDefs"
                :defaultColDef="defaultColDef"
                :rowClassRules="rowClassRules"
                :rowData="filteredSampleList"
                rowSelection="multiple"
                colResizeDefault="shift"
                :animateRows="true"
                :pagination="false"
                :suppressPaginationPanel="true"
                :enableRtl="$vs.rtl"></ag-grid-vue>
          </vx-card>
        </div>
      </div>
       <vs-popup class="holamundo" :title="$t('GradeControl.Sample.Importation.ResultTitle')" :active.sync="importationPopupActive">
        <vs-list>
          <div v-for="result in importationResults" class="mb-3" :key="result.description">
            <vs-list-header v-if="result.isSuccess" icon-pack="feather" icon="icon-clock" :title="result.description" color="success" />
            <vs-list-header v-else icon-pack="feather" icon="icon-clock" :title="result.description" color="danger" />
            <div v-for="message in result.messages" :key="message">
              <vs-list-item icon-pack="feather" icon="icon-alert-circle" :title="message"></vs-list-item>
            </div>
          </div>
        </vs-list>
      </vs-popup>
    </component>
    <sample-view
        :openSample = "selectedSample"
        :isSidebarActive = "isSidebarActive"
        @previousSample = "previousSample"
        @nextSample = "nextSample"
        @closeSidebar  = "closeSampleSidebar"
        @onUpdateSample = "updateSample">
    </sample-view>
  </div>
</template>
<script>
import { AgGridVue } from "ag-grid-vue";
import Vue from "vue";
import "@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss";
import moduleGradeControl from "@/store/geo/gradecontrol/moduleGradeControl.js";
import Datepicker from 'vuejs-datepicker';
import MeasuredElementEnum from './../MeasuredElementEnum.js';
import SampleStatusEnum from './../SampleStatusEnum';
import SampleActionsCellRenderer from './components/SampleActionsCellRenderer.vue'
import MeasuredElementCellRenderer from './components/MeasuredElementCellRenderer.vue'
import SampleView from './components/SampleView.vue'
import LimsSampleStats from './components/LimsSampleStats.vue'
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import { FormLabel } from "./../../../shared/components";
import TimesheetOperationTypeEnum from "../TimesheetOperationTypeEnum";

export default {
  components: {
    /* eslint-disable vue/no-unused-components */
    AgGridVue,
    Datepicker,
    SampleActionsCellRenderer,
    MeasuredElementCellRenderer,
    SampleView,
    VuePerfectScrollbar,
    FormLabel,
    LimsSampleStats
  },
  data() {
    return {
      isSidebarActive: false,
      settings : {
        maxScrollbarLength : 60,
        wheelSpeed         : 0.30
      },
      selectedDateTime: null,
      displayNotImported : false,
      selectedSampleDate: null,
      selectedProjectId: null,
      selectedSample: null,
      importationPopupActive: false,
      importationResults: [],
      sidebarData: {},
      showOnlyWarning: false,
      defaultColDef: {
        sortable: true,
        resizable: true,
        editable: false
      },
      gridApi: null,
      gridOptions: {
        getRowNodeId: (data) => {
          return data.sampleNumber;
        }
      },
      context: { componentParent: this },
      rowClassRules: {
        'sample-imported': 'data.status == ' + SampleStatusEnum.ImportedNoExclusion + ' || data.status == ' + SampleStatusEnum.ImportedWithExclusion
      },
      columnDefs: [
        {
          headerName: 'Actions',
          width: 140,
          editable: false,
          sortable: false,
          checkboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          headerCheckboxSelection: true,
          cellRendererFramework: Vue.extend(SampleActionsCellRenderer)
        },
        {
          headerName: this.$t('GradeControl.Sample.SampleNumber'),
          field: "sampleNumber",
          filter: true,
          width: 155
        },
        {
          headerName: this.$t('GradeControl.Timesheet.TimesheetOperationType'),
          field: "timesheetOperationType",
          filter: true,
          filterParams: {
            valueGetter: params => {
              if (params.data.timesheetOperationType !== null)
                return TimesheetOperationTypeEnum.getNameFor(params.data.timesheetOperationType);
              else
                return '';
            }
          },
          valueGetter: params => {
            if (params.data.timesheetOperationType !== null)
              return TimesheetOperationTypeEnum.getNameFor(params.data.timesheetOperationType);
            else
              return '';
          },
          width: 155
        },
        {
          headerName: this.$t('GradeControl.Sample.Certificate'),
          field: "certificate",
          filter: true,
          width: 150
        },
        {
          headerName: this.$t('SampleCategory.Title'),
          field: "category",
          width: 110,
          filter:'agTextColumnFilter',
          filterParams: {
            valueGetter: params => {
              return this.$t("SampleCategory." + params.data.category);
            }
          },
          valueGetter: params => {
            return this.$t("SampleCategory." + params.data.category);
          }
        },
        {
          headerName: this.$t('SampleStatus.Title'),
          field: "status",
          width: 150,
          filter:'agTextColumnFilter',
          filterParams: {
            valueGetter: params => {
              return this.$t("SampleStatus." + params.data.status);
            }
          },
          valueGetter: params => {
            return this.$t("SampleStatus." + params.data.status);
          }
        },
        {
          headerName: this.$systemUnits.getGradeLabel('Gold'),
          field: "sampleResultInfos",
          width: 150,
          filter:'agNumberColumnFilter',
          filterParams: {
            valueGetter: params => {
              return this.getGrade(params, MeasuredElementEnum.Gold);
            }
          },
          valueGetter: (params) => {
            return {
              grade : this.getGrade(params, MeasuredElementEnum.Gold),
              hasWarning : this.getHasWarning(params, MeasuredElementEnum.Gold)
            }
          },
          comparator:  (valueA, valueB) => {
            return this.compareGrade(valueA, valueB);
          },
          cellRendererFramework: Vue.extend(MeasuredElementCellRenderer)
        },
        {
          headerName: this.$systemUnits.getGradeLabel('Silver'),
          field: "sampleResultInfos",
          width: 150,
          filter:'agNumberColumnFilter',
          filterParams: {
            valueGetter: params => {
              return this.getGrade(params, MeasuredElementEnum.Silver);
            }
          },
          valueGetter: (params) => {
            return {
              grade : this.getGrade(params, MeasuredElementEnum.Silver),
              hasWarning : this.getHasWarning(params, MeasuredElementEnum.Silver)
            }
          },
          comparator:  (valueA, valueB) => {
            return this.compareGrade(valueA, valueB);
          },
          cellRendererFramework: Vue.extend(MeasuredElementCellRenderer)
        },
        {
          headerName: this.$t('Copper') + ' (%)',
          field: "sampleResultInfos",
          width: 150,
          filter:'agNumberColumnFilter',
          filterParams: {
            valueGetter: params => {
              return this.getGrade(params, MeasuredElementEnum.Copper);
            }
          },
          valueGetter: (params) => {
            return {
              grade : this.getGrade(params, MeasuredElementEnum.Copper),
              hasWarning : this.getHasWarning(params, MeasuredElementEnum.Copper)
            }
          },
          comparator:  (valueA, valueB) => {
            return this.compareGrade(valueA, valueB);
          },
          cellRendererFramework: Vue.extend(MeasuredElementCellRenderer)
        },
        {
          headerName: this.$t('Zinc') + ' (%)',
          field: "sampleResultInfos",
          width: 150,
          filter:'agNumberColumnFilter',
          filterParams: {
            valueGetter: params => {
              return this.getGrade(params, MeasuredElementEnum.Zinc);
            }
          },
          valueGetter: (params) => {
            return {
              grade : this.getGrade(params, MeasuredElementEnum.Zinc),
              hasWarning : this.getHasWarning(params, MeasuredElementEnum.Zinc)
            }
          },
          comparator:  (valueA, valueB) => {
            return this.compareGrade(valueA, valueB);
          },
          cellRendererFramework: Vue.extend(MeasuredElementCellRenderer)
        },
        {
          headerName: this.$t('Lead') + ' (%)',
          field: "sampleResultInfos",
          width: 150,
          filter:'agNumberColumnFilter',
          filterParams: {
            valueGetter: params => {
              return this.getGrade(params, MeasuredElementEnum.Lead);
            }
          },
          valueGetter: (params) => {
            return {
              grade : this.getGrade(params, MeasuredElementEnum.Lead),
              hasWarning : this.getHasWarning(params, MeasuredElementEnum.Lead)
            }
          },
          comparator:  (valueA, valueB) => {
            return this.compareGrade(valueA, valueB);
          },
          cellRendererFramework: Vue.extend(MeasuredElementCellRenderer)
        },
        {
          headerName: this.$t('Carbon') + ' (%)',
          field: "sampleResultInfos",
          width: 150,
          filter:'agNumberColumnFilter',
          filterParams: {
            valueGetter: params => {
              return this.getGrade(params, MeasuredElementEnum.Carbon);
            }
          },
          valueGetter: (params) => {
            return {
              grade : this.getGrade(params, MeasuredElementEnum.Carbon),
              hasWarning : this.getHasWarning(params, MeasuredElementEnum.Carbon)
            }
          },
          comparator:  (valueA, valueB) => {
            return this.compareGrade(valueA, valueB);
          },
          cellRendererFramework: Vue.extend(MeasuredElementCellRenderer)
        },
        {
          headerName: this.$t('Sulfur') + ' (%)',
          field: "sampleResultInfos",
          width: 150,
          filter:'agNumberColumnFilter',
          filterParams: {
            valueGetter: params => {
              return this.getGrade(params, MeasuredElementEnum.Sulfur);
            }
          },
          valueGetter: (params) => {
            return {
              grade : this.getGrade(params, MeasuredElementEnum.Sulfur),
              hasWarning : this.getHasWarning(params, MeasuredElementEnum.Sulfur)
            }
          },
          comparator:  (valueA, valueB) => {
            return this.compareGrade(valueA, valueB);
          },
          cellRendererFramework: Vue.extend(MeasuredElementCellRenderer)
        }
      ],
      components: {
        SampleActionsCellRenderer,
        MeasuredElementCellRenderer
      }
    };
  },
  watch: {
    selectedDateTime(val) {
      if (!val) return;

      if (this.selectedDateTime) {
        this.$refs.dateCard.refreshcard();
      }
    }
  },
  computed: {
    sampleListTitle() {
      const sampleList = this.displayNotImported ? this.$t('GradeControl.Sample.NotImported') : this.sampleDate
      return this.$t('GradeControl.Sample.SampleList') + " - " + sampleList;
    },
    filteredSampleList() {
      if (this.showOnlyWarning) {
        return this.sampleList.filter(l => l.sampleResultInfos.some(r => r.hasWarning));
      } else {
        return this.sampleList;
      }
    },
    sampleList() {
      return this.$store.state.gradeControl.limsSamples;
    },
    selectedDate() {
      if (this.selectedDateTime)
        return this.$options.filters.toDate(this.selectedDateTime);
      else
        return '';
    },
    sampleDate() {
      if (this.selectedSampleDate)
        return this.$options.filters.toDate(this.selectedSampleDate);
      else
        return '';
    },
    selectedStartDate() {
      return new Date(this.selectedDateTime);
    },
    selectedEndDate() {
      if (this.selectedDateTime) {
        const d = new Date(this.selectedDateTime.valueOf())
        d.setMonth(d.getMonth() + 1);
        if (d.getDate() !== d) {
          d.setDate(0);
        }

        return d;
      }
      else
        return null;
    },
    scrollbarTag () {
      return this.$store.getters.scrollbarTag
    }
  },
  mounted() {
    this.gridApi = this.gridOptions.api;
    this.$store.dispatch("gradeControl/clearSampleListItems");
    this.displayNotImported = false;
  },
  created() {
    if (!moduleGradeControl.isRegistered) {
      this.$store.registerModule("gradeControl", moduleGradeControl);
      moduleGradeControl.isRegistered = true;
    }

    this.selectedProjectId = Number(this.$store.state.projectId);
    const today = new Date();
    this.selectedDateTime = new Date(today.getFullYear(), today.getMonth(), 1);
  },
  methods: {
    refreshStats() {
      this.$refs.limsStats.refreshData(this.selectedStartDate, this.selectedEndDate).finally(() => {
        this.$refs.dateCard.removeRefreshAnimation()
      });
    },
    selectDate(val) {
      this.displayNotImported = false;
      this.selectedSampleDate = val;
      this.$refs.sampleListCard.refreshcard();
    },
    displayAllNotImported() {
      this.displayNotImported = true;
      this.selectedSampleDate = null;
      this.$refs.sampleListCard.refreshcard();
    },
    selectSample(val) {
      this.selectedSample = val;
      this.isSidebarActive = true
    },
    toggleDataSidebar(val = false) {
      this.sampleDataSidebar = val;
    },
    getGrade(params, elementId) {
      if (params.data.sampleResultInfos !== null) {
        const sampleResult = params.data.sampleResultInfos.find(r => r.element === elementId)
        if (sampleResult) {
          return this.$systemUnits.convertGradeRounded(sampleResult.grade, elementId);
        }
        else {
          return null;
        }
      }
      else {
        return null;
      }
    },
    getHasWarning(params, elementId) {
      if (params.data.sampleResultInfos !== null) {
        const sampleResult = params.data.sampleResultInfos.find(r => r.element === elementId)
        if (sampleResult && sampleResult.hasWarning) {
          if (sampleResult.hasExclusion)
            return 1;
          else
            return 2;
        }
        else {
          return 0;
        }
      }
      else {
        return 0;
      }
    },
    getSampleEntries() {
      if (this.selectedSampleDate) {
        this.$store.dispatch("gradeControl/fetchLimsSampleListItems",  {
          selectedDate: this.selectedSampleDate,
          projectId: this.selectedProjectId
        }).then(() => {
          this.$refs.sampleListCard.removeRefreshAnimation()
        });
      }
      else if (this.displayNotImported) {
        this.$store.dispatch("gradeControl/fetchNonApprovedLimsSampleListItems",  {
          selectedDate: this.selectedDate,
          projectId: this.selectedProjectId
        }).then(() => {
          this.$refs.sampleListCard.removeRefreshAnimation()
        });
      }
    },
    compareGrade(valueA, valueB) {
      if (valueA.grade === valueB.grade) {
        return 0;
      }
      else {
        const a = valueA.hasWarning ? valueA.grade * 100 : valueA.grade;
        const b = valueB.hasWarning ? valueB.grade * 100 : valueB.grade;
        return (a > b) ? 1 : -1;
      }
    },
    formatDateTime(params) {
      return this.$options.filters.toDate(params.value);
    },
    openImportConfirm() {
      const rows = this.gridApi.getSelectedRows();
      if (rows.length === 0) {
        this.$vs.dialog({
          color: 'danger',
          title: this.$t("Import"),
          text: this.$t('GradeControl.Sample.NoSampleSelected')
        })
      }
      else {
        this.$vs.dialog({
          type: "confirm",
          color: "warning",
          title: this.$t("Import"),
          text: this.$t('GradeControl.Sample.ConfirmImport'),
          accept: this.import
        });
      }
    },


    import() {
      const rows = this.gridApi.getSelectedRows();

      const sampleDates = Object.assign({}, ...rows.map((x) => ({[x.sampleNumber]: x.certifiedDate})));

      this.$vs.loading();
      this.$webApi.post('geo/gradecontrol/SampleImportation/', {
        sampleDates,
        projectId: this.selectedProjectId
      }).then((result) => {

        if (result.data.isSuccess) {
          this.$vs.notify({
            title: this.$t("Import"),
            text: this.$t("GradeControl.Sample.ImportCompleted"),
            color: "success",
            iconPack: 'feather',
            icon:'icon-check'
          });
        }
        else {
          this.importationPopupActive = true;
          this.importationResults = result.data.results;
        }

        this.$refs.sampleListCard.refreshcard();
        this.$refs.dateCard.refreshcard();

      }).finally(() => {
        this.$vs.loading.close();
      });
    },
    openCancelImportConfirm() {
      const rows = this.gridApi.getSelectedRows();
      if (rows.length === 0) {
        this.$vs.dialog({
          color: 'danger',
          title: this.$t("Import"),
          text: this.$t('GradeControl.Sample.NoSampleSelected')
        })
      }
      else {
        this.$vs.dialog({
          type: "confirm",
          color: "warning",
          title: this.$t("Import"),
          text: this.$t('GradeControl.Sample.ConfirmCancelImportBatch'),
          accept: this.cancelImportBatch
        });
      }
    },

    cancelImportBatch() {
      const rows = this.gridApi.getSelectedRows();
      this.$vs.loading();
      this.$webApi.post('geo/gradecontrol/SampleImportation/CancelImportation/', {
        sampleNumbers: rows.map(s => s.sampleNumber),
        projectId: this.selectedProjectId,
        certificationDate : this.selectedSampleDate
      }).then(() => {

        this.$vs.notify({
          title: this.$t("Import"),
          text: this.$t("GradeControl.Sample.CancelImportCompletedBatch"),
          color: "success",
          iconPack: 'feather',
          icon:'icon-check'
        });

        this.$refs.sampleListCard.refreshcard();
        this.$refs.dateCard.refreshcard();

      }).finally(() => {
        this.$vs.loading.close();
      });
    },
    cancelImportation(sample) {
      this.$vs.loading();
      this.$webApi.post('geo/gradecontrol/SampleImportation/CancelImportation/', {
        sampleNumbers: [sample.sampleNumber],
        projectId: this.selectedProjectId,
        certificationDate : this.selectedSampleDate
      }).then(() => {

        this.$vs.notify({
          title: this.$t("Import"),
          text: this.$t("GradeControl.Sample.CancelImportCompleted"),
          color: "success",
          iconPack: 'feather',
          icon:'icon-check'
        });

        this.$refs.sampleListCard.refreshcard();
        this.$refs.dateCard.refreshcard();

      }).finally(() => {
        this.$vs.loading.close();
      });
    },
    doImportation(sample) {

      const samples = [sample]
      const sampleDates = Object.assign({}, ...samples.map((x) => ({[x.sampleNumber]: x.certifiedDate})));

      this.$vs.loading();
      this.$webApi.post('geo/gradecontrol/SampleImportation/', {
        sampleDates,
        projectId: this.selectedProjectId,
        certificationDate : this.selectedSampleDate
      }).then((result) => {
        if (result.data.isSuccess) {
          this.$vs.notify({
            title: this.$t("Import"),
            text: this.$t("GradeControl.Sample.ImportCompleted"),
            color: "success",
            iconPack: 'feather',
            icon:'icon-check'
          });
        }
        else {
          this.importationPopupActive = true;
          this.importationResults = result.data.results;
        }

        this.$refs.sampleListCard.refreshcard();
        this.$refs.dateCard.refreshcard();

      }).finally(() => {
        this.$vs.loading.close();
      });
    },
    nextSample () {
      const currentSampleIndex = this.filteredSampleList.findIndex((s) => s.sampleNumber === this.selectedSample.sampleNumber)
      if (this.filteredSampleList[currentSampleIndex + 1]) this.selectedSample = this.filteredSampleList[currentSampleIndex + 1];
    },
    previousSample () {
      const currentSampleIndex = this.filteredSampleList.findIndex((s) => s.sampleNumber === this.selectedSample.sampleNumber)
      if (this.filteredSampleList[currentSampleIndex - 1]) this.selectedSample = this.filteredSampleList[currentSampleIndex - 1];
    },
    updateSample() {
      this.$store.dispatch("gradeControl/fetchLimsSampleListItems",  {
        selectedDate: this.selectedSampleDate,
        projectId: this.selectedProjectId
      });
      this.$refs.limsStats.refreshData(this.selectedStartDate, this.selectedEndDate)
    },
    closeSampleSidebar () {
      this.isSidebarActive = false
    }
  }
};
</script>
<style lang="scss">
#sample-view {
  .vs-sidebar--background {
    position: absolute;
  }
  .full-vs-sidebar {
    .vs-sidebar {
      max-width: 100%;
    }
  }

  .sample-imported {
    border-width: 1 !important;
    border-style: solid !important;
    border-color:  #339900 !important;
  }

  .con-vs-popup {
    .vs-popup {
      width: 1200px !important;
      height: auto !important;
    }
  }

  .select-all-chexkbox{
      .vs-checkbox{
          margin-right: 0.8rem;
      }
  }

  .scroll-area-sample-content {
    position: relative;
    margin: auto;
    width: 100%;
    height: calc(100% - 6.3%);

    &:not(.ps) {
      overflow-y: auto;
    }
  }

  .sample-view-sidebar {
    .vs-sidebar{
        background-color: #f8f8f8 !important;
        border-left: 1px solid #dae1e7;
    }

    .sample-header{
        box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.04);
        border-bottom: 1px solid #eee;
        z-index: 1;
        position: relative;
    }

    .mail__attachment {
      .vs-chip--text {
        margin-left: 0;
        margin-right: 0;
      }
    }
  }

  .sample-list-filters {
    .vs__actions {
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-58%);
    }
  }
}

</style>
